(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init() {
    document.querySelectorAll('[data-amz-sticky]').forEach(function (bar) {
      if (bar.dataset.amzInit) return;
      bar.dataset.amzInit = '1';
      var section = bar.closest('.shopify-section') || document;
      function set(v) { bar.classList.toggle('is-visible', v); }
      if (bar.getAttribute('data-sticky-when') !== 'buy_box_hidden') {
        /* show after a little scrolling, like the Ototo bar */
        function onScroll() { set(window.scrollY > 100); }
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
        document.body.style.paddingBottom = (bar.offsetHeight + 24) + 'px';
        return;
      }
      var target = section.querySelector('[data-amz-main]') || section.querySelector('.product-info__buy-buttons');
      if (!target || !('IntersectionObserver' in window)) { set(true); return; }
      new IntersectionObserver(function (entries) { set(!entries[0].isIntersecting); }, { threshold: 0 }).observe(target);
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

(function () {
  function initReels(reels) {
    if (reels.dataset.fpInit) return;
    reels.dataset.fpInit = '1';
    var btns = reels.querySelectorAll('.fp-reel');
    var tpls = reels.querySelectorAll('template[data-reel-video]');
    var dlg = reels.querySelector('.fp-reel-dialog');
    var body = dlg.querySelector('.fp-reel-dialog__body');
    var cur = 0;
    function show(i) {
      if (i < 0) i = btns.length - 1;
      if (i >= btns.length) i = 0;
      cur = i;
      body.innerHTML = '';
      body.appendChild(tpls[i].content.cloneNode(true));
      var v = body.querySelector('video');
      if (v) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
    }
    function closeDlg() {
      var v = body.querySelector('video');
      if (v) v.pause();
      body.innerHTML = '';
      if (dlg.open) { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); }
    }
    Array.prototype.forEach.call(btns, function (b, i) {
      b.addEventListener('click', function () {
        show(i);
        if (!dlg.open) { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); }
      });
    });
    dlg.querySelector('[data-reel-close]').addEventListener('click', closeDlg);
    dlg.querySelector('[data-reel-prev]').addEventListener('click', function () { show(cur - 1); });
    dlg.querySelector('[data-reel-next]').addEventListener('click', function () { show(cur + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) closeDlg(); });
    dlg.addEventListener('cancel', function () { var v = body.querySelector('video'); if (v) v.pause(); });
  }

  function initReviews(rev) {
    if (rev.dataset.fpInit) return;
    rev.dataset.fpInit = '1';
    var rail = rev.querySelector('.fp-reviews__rail');
    var cards = rail.querySelectorAll('.fp-review');
    var dots = rev.querySelector('.fp-reviews__dots');
    var cur = 0;
    function step() {
      var cs = getComputedStyle(rail);
      var gap = parseFloat(cs.columnGap || cs.gap) || 14;
      return cards[0].offsetWidth + gap;
    }
    function setOn(i) {
      cur = i;
      Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-on', k === i); });
    }
    Array.prototype.forEach.call(cards, function (c, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'fp-reviews__dot' + (i === 0 ? ' is-on' : '');
      d.setAttribute('aria-label', 'Go to review ' + (i + 1));
      d.addEventListener('click', function () { rail.scrollTo({ left: i * step(), behavior: 'smooth' }); });
      dots.appendChild(d);
    });
    var tick = false;
    rail.addEventListener('scroll', function () {
      if (tick) return;
      tick = true;
      window.requestAnimationFrame(function () {
        var i = Math.round(rail.scrollLeft / step());
        if (i < 0) i = 0;
        if (i > cards.length - 1) i = cards.length - 1;
        if (i !== cur) setOn(i);
        tick = false;
      });
    }, { passive: true });
    rev.querySelector('[data-prev]').addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    rev.querySelector('[data-next]').addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
  }

  function init() {
    document.querySelectorAll('[data-fp-reels]').forEach(initReels);
    document.querySelectorAll('[data-fp-reviews]').forEach(initReviews);
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();
})();
